import moment from 'moment'

if (!localStorage.aio_locale) localStorage.setItem('aio_locale', 'en')
moment.locale(localStorage.aio_locale)

// =========
// Vue setup
// ---------
import Vue from 'vue'
import VueBus from 'vue-bus'
import VueI18n from 'vue-i18n'
import AsyncMethods from 'vue-async-methods'
import money from 'v-money'

if (Vue.config.devtools) {
  window.store = store
  window.api = api
}

Vue.config.productionTip = false

Vue.use(AsyncMethods)
if (!Vue.bus) Vue.use(VueBus)
Vue.use(money, {precision: 2})
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.aio_locale,
  fallbackLocale: 'en',
  messages: {
    en: messages_en,
    de: messages_de,
  },
})
// =========

// ========
// F7 setup
// --------
import Framework7 from 'framework7/framework7.esm.bundle'
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle'

Framework7.use(Framework7Vue)

// F7 Base Stylesheets
import 'framework7/css/framework7.bundle.min.css'
// Icon styles
import 'framework7-icons'
import 'material-design-icons/iconfont/material-icons.css'
// ========

// Setup *our* code
import cordovaHelpers from './utils/cordova-helpers'
import messages_en from '@/utils/i18n_en'
import messages_de from '@/utils/i18n_de'
import store from '@/store'
import beta from '@/utils/beta'
import api from 'aio-api'

import App from '@/app'

Vue.use(beta)

cordovaHelpers.loadCordova(() => {
  new Vue({
    render: h => h(App),
    store,
    i18n,
  }).$mount('#app')
})
